<template>
  <div>
    <HeaderBreadcrumbs :items="[
      { label: 'Books', to: '/ebooks' },
      { label: 'Bulk Update File Books', to: '/items/bulk/upload/books' },
      { label: 'Log Activity', to: '/items/bulk/log_activity/books' },
      { label: formattedDateTime }
    ]" :title="formattedDateTime" />

    <div class="border rounded-xl overflow-hidden mb-5  bg-white p-3">
      <div class="bg-orange-50 h-auto py-2 px-3 rounded-lg flex-col w-full">
           <div class="flex items-baseline justify-start">
             <img src="../../assets/img/information-circle.svg" class="w-4 h-5 mr-2 relative top-1" />
              <label class="text-sm font-semibold text-yellow-800 mb-2">Upload Completed</label>
           </div>

        <p class="text-xs mt-0 text-yellow-800">Your files have been successfully uploaded and moved to “Need Approval” status. If any files failed to process, please re-upload them.</p>
      </div>
      <div class="flex items-center px-3 py-4 my-1  pt-3 text-xs font-semibold">
        <Label class="mr-2">Filter: </Label>

        <label class="mr-4">
          <input
            type="radio"
            value="all"
            class="mr-2"
            v-model="filterStatus"
            :disabled="isLoading"
            @change="filterByStatus"
          />
          All
        </label>

        <label class="mr-4">
          <input
            type="radio"
             class="mr-2"
            :value="STATUS.SUCCESS"
            v-model="filterStatus"
            :disabled="isLoading"
            @change="filterByStatus"
          />
          Successfully ({{this.successCount}})
        </label>

        <label>
          <input
            type="radio"
             class="mr-2"
            :value="STATUS.FAILED"
            v-model="filterStatus"
            :disabled="isLoading"
            @change="filterByStatus"
          />
          Failed ({{this.failedCount}})
        </label>
      </div>
      <div class="border rounded-xl overflow-hidden">
 <Table
        :headers="headers"
        :data="filteredItems"
        :withNumberCol="false"
        :row-key="['file_name','item_id','file_size','format_file','status','error']"
        :current-page="currentPage"
        :isLoading="isLoading"
        :per-page="15"
      >
        <template #file_size="{ value }">
          {{ formatSize(value) }}
        </template>
          <template class="uppercase" #format_file="{ value }">
          <span class="uppercase">{{ value }}</span>
        </template>

        <template #status="{ value }">
          <span :class="getStatusMeta(value).class" class="rounded-lg text-xs p-1.5">
            {{ getStatusMeta(value).label }}
          </span>
        </template>
      </Table>
      </div>
    </div>
      
  </div>
</template>

<script>
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import Table from '@/components/form/table.vue'

const STATUS = {
  NEW: 1,
  PROCESSING: 2,
  SUCCESS: 10,
  FAILED: 11
}

export default {
  components: {
    HeaderBreadcrumbs,
    Table
  },

  data() {
    return {
      currentPage: 1,
      bulk_id: '',
      filterStatus: 'all', // 🔥 penting
      STATUS,
      successCount: 0,
      failedCount: 0,
      headers: [
        {},
        { label: 'Content Name', key: '' },
        { label: 'Content id', key: '' },
        { label: 'size', key: '' },
        { label: 'format', key: '' },
        { label: 'status', key: '' },
        { label: 'reason', key: '' }
      ]
    }
  },

  mounted() {
    this.bulk_id = history.state?.id || this.$route.query.id
    this.fetchBulkItemId()
   
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Ebook | Content Management System Ebooks Gramedia.com';
      },
    },
   items: {
  immediate: true,
  handler(data) {

    const count = data.reduce((acc, row) => {
      const status = Number(row.status)

      if (status === 10) acc.success++
      if (status === 11) acc.failed++

      return acc
    }, { success: 0, failed: 0 })
    this.successCount = count.success
    this.failedCount = count.failed

  }
}
  },
  computed: {
    ...mapState({
      items: state => state.bulkUpload.items,
      totalRows: state => state.bulkUpload.totalRows,
      isLoading: state => state.bulkUpload.isLoading
    }),

    formattedDateTime() {
      const dt = this.$route.params.date
      return dt ? moment(dt).format('DD/MM/YYYY, HH:mm') : ''
    },

    filteredItems() {
      if (this.filterStatus === 'all') return this.items
      return this.items.filter(item => item.status === this.filterStatus)
    }
    
  },

  methods: {
    ...mapActions('bulkUpload', ['getBulkItemId']),

    fetchBulkItemId() {
      this.getBulkItemId({
        item_type: 'book',
        page: this.currentPage,
        limit: 15,
        bulk_id: this.bulk_id
      })
    },

    onClickPage(page) {
      this.currentPage = page
      this.fetchBulkItemId()
    },

    filterByStatus() {
      console.log('filter:', this.filterStatus)
    },

    getStatusMeta(status) {
      switch (status) {
        case STATUS.NEW:
          return { label: 'New', class: 'bg-gray-400 text-white' }
        case STATUS.PROCESSING:
          return { label: 'Processing', class: 'bg-yellow-400 text-white' }
        case STATUS.SUCCESS:
          return { label: 'Success', class: 'bg-green-500 text-white' }
        case STATUS.FAILED:
          return { label: 'Failed', class: 'bg-red-500 text-white' }
        default:
          return { label: 'Unknown', class: 'bg-gray-200 text-black' }
      }
    },

    formatSize(bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      if (!bytes) return '0 Byte'
      const i = Math.floor(Math.log(bytes) / Math.log(1024))
      return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i]
    }
  }
}
</script>